module.exports = __webpack_public_path__ + "media/media/values/face-1-9d184906922c52e45969d5565321775b.jpg";